/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';
import { PreDocumentUpdateDto } from '../../models/pre-document-update-dto';

export interface PreDocumentControllerUpdate$Params {

/**
 * 센터 아동 ID
 */
  centerChildId: string;

/**
 * 문서 유형
 */
  type: '\uAE30\uBCF8\uC0C1\uB2F4\uC9C0' | '\uC2EC\uD654\uC0C1\uB2F4\uC9C0' | '\uD3C9\uAC00\uBCF4\uACE0\uC11C' | '\uBC1C\uB2EC\uC7AC\uD65C\uC11C\uBE44\uC2A4\uC758\uB8B0\uC11C' | '\uC544\uB3D9\uCCAD\uC18C\uB144\uC2EC\uB9AC\uC11C\uBE44\uC2A4\uC758\uB8B0\uC11C';
      body: PreDocumentUpdateDto
}

export function preDocumentControllerUpdate(http: HttpClient, rootUrl: string, params: PreDocumentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
  const rb = new RequestBuilder(rootUrl, preDocumentControllerUpdate.PATH, 'post');
  if (params) {
    rb.query('centerChildId', params.centerChildId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDto>;
    })
  );
}

preDocumentControllerUpdate.PATH = '/api/pre-document';
